import React from 'react';
import PropTypes from 'prop-types';
import DateSelectorGrid from './DateSelectorGrid';
import { DatePropType } from '../helpers/common';

function DateSelectorMonthsView({
  onMonthChange,
  selectedMonth,
  minDate,
  maxDate,
  months,
  selectedYear
}) {
  const currentDate = new Date(Date.now());

  return (
    <DateSelectorGrid
      data={months}
      selected={months[selectedMonth]}
      current={months[currentDate.getMonth()]}
      currentYear={currentDate.getFullYear()}
      onItemClick={(item, key) => onMonthChange(key)}
      testPrefix="MonthCell"
      minDate={minDate}
      maxDate={maxDate}
      selectedYear={selectedYear}
      type="months"
    />
  );
}

DateSelectorMonthsView.propTypes = {
  onMonthChange: PropTypes.func,
  selectedMonth: PropTypes.number,
  minDate: DatePropType,
  maxDate: DatePropType,
  months: PropTypes.array.isRequired,
  selectedYear: PropTypes.number
};

export default DateSelectorMonthsView;
